import React from "react";
import "./mapLoadingSkeleton.scss";

function MapLoadingSkeleton() {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: 500,
        top: 0,
        left: 0,
        zIndex: 10000,
        backgroundColor: "black",
        opacity: 0.2,
      }}
    >
      <div className="d-flex w-100 h-100 justify-content-center align-items-center">
        <div className="lds-map-roller">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
}

export default MapLoadingSkeleton;
